import CiroTextInput from "../../../../../shared/CiroTextInput";
import { IPowersearchFieldValueProps } from "./PowersearchFieldValue";

const PowersearchTextInputEditor = ({
  value,
  handleOnChange,
  disabled,
  errorMessage,
  type,
}: IPowersearchFieldValueProps & { type: "number" | "text" }) => {
  return (
    <CiroTextInput
      type={type}
      value={value}
      onChange={(e) => handleOnChange(e.target.value)}
      disabled={disabled}
      error={errorMessage}
    />
  );
};

export default PowersearchTextInputEditor;
